import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/ai-apis"
    exact
    path="/business/ai-apis"
    component={AsyncPage}
  />,
];
